<template>
  <!-- Текст сверху на странице бренда и на странице группы товаров
       (админка → Сайт → Бренды и дисклеймеры → «Тексты на странице бренда»). -->
  <div v-if="intro.heading" class="brand-intro">
    <p class="brand-intro__heading">{{ intro.heading }}</p>
    <p v-if="intro.subheading" class="brand-intro__text brand-intro__sub">{{ intro.subheading }}</p>
    <p v-for="(line, i) in intro.lines" :key="i" class="brand-intro__text">{{ line }}</p>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {useSiteSettings} from "@/functions/siteSettings";

const catalog = useSiteSettings("catalog");
const intro = computed(() => {
  const c = catalog.value || {};
  return {
    heading: (c.brandIntroHeading || "").trim(),
    subheading: (c.brandIntroSubheading || "").trim(),
    lines: String(c.brandIntroText || "").split(/\r?\n/).map((l) => l.trim()).filter(Boolean),
  };
});
</script>

<style scoped>
/* Обычный текст сайта (Circe, цвет #272930), на всю ширину, без отступов между абзацами;
   жирная только первая строка */
.brand-intro {
  margin: -20px 0 40px;
  font-size: 16px;
  line-height: 1.55;
  color: #272930;
}
.brand-intro__heading {
  text-align: center;
  font-family: "Circe-Bold", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.brand-intro p {
  margin: 0;
  text-wrap: pretty; /* не оставлять одно слово на последней строке */
}
@media (max-width: 767px) {
  .brand-intro {
    margin: -10px 0 26px;
    font-size: 14px;
  }
}
</style>
